import { useContext } from 'react';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { MyTicketsDesktop } from './components/desktop/MyTicketsDesktop';
import { MyTicketsMobile } from './components/mobile/MyTicketsMobile';

export const MyTickets = () => {
  const { isMobile } = useContext(TeamsFxContext);

  return <>{isMobile ? <MyTicketsMobile /> : <MyTicketsDesktop />}</>;
};
